import React, { Component } from "react";
require('./index.less')
export default class NotFound extends Component {
    render() {
        return  <section className="not-found">
            页面不存在~
        </section>
    }
}
